import { Component, EventEmitter, Output, OnInit, Input, SimpleChanges, OnChanges } from "@angular/core";
import { NgbCalendar, NgbDate } from "@ng-bootstrap/ng-bootstrap";
import {DuplicateLinkedAccountEnum, BlockedBalanceEnum, FibraFacilEnum, LimitIncreaseEnum, LimitIncreaseResultEnum, SimulatorLimitUseEnum, SimulatorResultEnum, DetailsTransacionEnum } from "@src/shared/enum/bfd-popover.enum";
import { PopoverService } from "@src/shared/services/popover.service";
import * as moment from 'moment';

@Component({
  selector: "bfd-popover",
  templateUrl: "./bfd-popover.component.html",
  styleUrls: ["./bfd-popover.component.scss"],
})
export class ExtractPopoverComponent implements OnInit, OnChanges {
  @Input() view!: string;
  @Input() content!: any;
  @Input() alertBadge?: string;
  @Output() dataEmitter: EventEmitter<any> = new EventEmitter<any>();
  
  public visible: boolean = false;
  public img?: string;
  public title!: string;
  public subtitle!: string;
  public description!: string;
  public alertBottom!: string;

  public value!: number;
  public date!: NgbDate;
  public dateFinal!: NgbDate;
  public maxDate!: NgbDate;
  public maxDateFinal!: NgbDate;
  public minDate!: NgbDate;
  public minDateFinal!: NgbDate;

  public inicialDate!: string;
  public finalDate!: string;
  public iconInput = {
    type: 'icon',
    typeColor: 'danger',
    img: 'wallet',
    size: 'large'
  }

  constructor(
    private calendar: NgbCalendar,
    public popoverService: PopoverService,
  ) {
    this.minDate = this.calendar.getToday();
    this.date = this.calendar.getToday();
    this.maxDate = NgbDate.from({
      year: new Date().getFullYear() + 1,
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
    });

    this.maxDateFinal = NgbDate.from({
      year: new Date().getFullYear() + 1,
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
    });

    this.addOnMonth(this.minDate);
  }

  ngOnInit(): void {
    this.popoverService.modalVisibility$.subscribe(visible => {
      this.visible = visible;
    });
    this.selecView();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selecView();
  }

  public selecView(): void {
    switch (this.view) {
      case FibraFacilEnum.TypeView:
        this.img = 'pict-fibra-facil';
        this.title = FibraFacilEnum.Title;
        this.subtitle = FibraFacilEnum.Subtitle;
        this.description = FibraFacilEnum.MessageLimitUnavailable;
        this.iconInput = {
          type: 'icon',
          typeColor: 'danger',
          img: 'wallet',
          size: 'large'
        }
        this.alertBottom = '';
        break;
      case LimitIncreaseEnum.TypeView:
        this.title = LimitIncreaseEnum.Title;
        this.subtitle = LimitIncreaseEnum.Subtitle;
        this.img = 'info-limit-increase';
        this.alertBottom = '';
        break;

      case LimitIncreaseResultEnum.TypeView:
        this.title = LimitIncreaseResultEnum.Title;
        this.subtitle = LimitIncreaseResultEnum.Subtitle;
        this.img = 'icon-encrease-limit';
        this.alertBottom = '';
        break;

      case SimulatorLimitUseEnum.TypeView:
        this.title = SimulatorLimitUseEnum.Title;
        this.subtitle = SimulatorLimitUseEnum.Subtitle;
        this.img = '';
        this.alertBottom = SimulatorLimitUseEnum.DescriptionAlert;
        break;

      case SimulatorResultEnum.TypeView:
        this.title = SimulatorResultEnum.Title;
        this.subtitle = SimulatorResultEnum.Subtitle;
        this.img = '';
        this.alertBottom = SimulatorResultEnum.DescriptionAlert;
        break;

      case BlockedBalanceEnum.TypeView:
          this.title = BlockedBalanceEnum.Title;
          this.subtitle = BlockedBalanceEnum.Subtitle;
          this.iconInput = {
            type: 'pictograma',
            typeColor: '',
            img: 'pict-blocked',
            size: 'small'
          }
          this.alertBottom = '';
          break;

      case DuplicateLinkedAccountEnum.TypeView:
          this.title = DuplicateLinkedAccountEnum.Title;
          this.subtitle = DuplicateLinkedAccountEnum.Subtitle;
          this.img = 'pict-fibra-facil';
          this.alertBottom = '';
          break;

      case DetailsTransacionEnum.TypeView:
          this.title = this.content.descHistorico ? this.content.descHistorico : this.content.desc_historico;
          this.subtitle = '';
          this.iconInput = {
            type: 'icon',
            typeColor: this.content.natureza ? this.getColorIcon(this.content.natureza) : this.getColorIcon(this.content.cod_deb_cred),
            img: 'bfd-payments',
            size: 'large'
          };
          this.alertBottom = '';
          break;
    }
  }

  public encreaseLimit(): void {
    this.view = 'limit-increase';
    this.selecView();
  }

  public dateSelect(event) {
    this.date = event;
    this.addOnMonth(event);
    console.log(this.dateFinal)
  }

  public dateSelectFinal(event) {
    this.dateFinal = event;
  }

  public addOnMonth(date): void {
    const jsDate = new Date(
      date.year,
      date.month - 1,
      date.day
    );

    const datePlus1 = moment(jsDate).add(1, 'days');
    const datePlus30 = moment(jsDate).add(30, 'days');

    this.minDateFinal = NgbDate.from({
      year: datePlus1.year(),
      month: datePlus1.month() + 1,
      day: datePlus1.date()
    });

    this.maxDateFinal = NgbDate.from({
      year: datePlus30.year(),
      month: datePlus30.month() + 1,
      day: datePlus30.date()
    });

    this.dateFinal = NgbDate.from({
      year: datePlus30.year(),
      month: datePlus30.month() + 1,
      day: datePlus30.date()
    });

  }

  public limitIncrease($event): void {
    if (this.view === 'limit-increase') {
      this.view = 'limit-increase-result';
      this.selecView();
      return;
    }

    this.close();
  }

  public sendSimulation($event): void {
    if (this.view === 'simulator-limit-use') {
      this.view = 'simulator-result';
      this.selecView();
      return;
    }

    this.close();
  }

  public limitSimulator(): void {
    this.view = 'simulator-limit-use';
    this.selecView();
  }

  public close(): void {
    this.popoverService.closeModal();
    this.selecView();
  }

  private getColorIcon(typeTransaction: string): string {
    return typeTransaction === 'C' ? 'primary' : 'danger'
  }

  public downloadReceipt(id: number): void {
    this.dataEmitter.emit(id);
  }
}
